import axios from "axios";

//登录验证
export async function check_Login(url,userID){
    try {
        let response = await axios.post(url+"/app01/check_Login",{
            userID:userID, 
        });
        let data = response.data
        console.log(data)
        return data
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}

//会员有效期验证
export async function check_vip_date(url,userID){
    try {
        let response = await axios.post(url+"/app01/check_vip_date",{
            userID:userID, 
        });
        let data = response.data
        console.log("check_vip_date:::",data)
        return data
    } catch (error) {
        console.error('Error fetching data:', error);
    }
}


// 封装localStorage读写，统一处理JSON序列化/反序列化，全局可调用
export const storage = {
  
  set(key, data) {
    try {
      // 统一序列化，解决localStorage只能存字符串的问题
      const storeData = JSON.stringify(data);
      localStorage.setItem(key, storeData);
      // console.log(`✅ 缓存写入成功：${key}`);
    } catch (error) {
      console.error(`❌ 缓存写入失败：${key}`, error);
    }
  },

  
  get(key) {
    try {
      const data = localStorage.getItem(key);
      // 无数据返回null，有数据自动反序列化
      return data ? JSON.parse(data) : null;
    } catch (error) {
      console.error(`❌ 缓存读取失败：${key}`, error);
      return null;
    }
  },

 
  remove(key) {
    try {
      localStorage.removeItem(key);
      console.log(`✅ 缓存删除成功：${key}`);
    } catch (error) {
      console.error(`❌ 缓存删除失败：${key}`, error);
    }
  },

 
  clear() {
    localStorage.clear();
    console.log("✅ 所有本地缓存已清空");
  }
};


const utils = {
  check_Login,
  check_vip_date,
  storage,
};

export default utils;